<template>
  <div class="ma-4">
    <Table
      module="BOL"
      title="BOL"
      :items="allBOLs"
      :headers="headers"
      :totalItems="totalItems"
      sortKey="createDate"
    >
      <template v-slot:data="{ props }">
        <td>{{ props.item.vendor.name }}</td>
        <td>{{ props.item.route }}</td>
        <td>{{ props.item.customer }}</td>
        <td>{{ props.item.reference }}</td>
        <td>{{ props.item.packageType }}</td>
        <td>{{ props.item.packageCount }}</td>
        <td>{{ localizeDate(props.item.createDate, true) }}</td>
        <td>{{ props.item.createdBy.name }}</td>
        <td>
          <v-btn @click="uploadImage(props.item._id)" flat icon class="mx-0">
            <v-icon small>fa fa-upload</v-icon>
          </v-btn>
          <v-btn
            @click="viewImages(props.item._id)"
            flat
            icon
            class="mx-0"
            :disabled="props.item.imageCount < 1"
          >
            <v-icon small>fa fa-images</v-icon>
          </v-btn>
        </td>
      </template>
    </Table>

    <v-dialog
      v-model="imageView"
      persistent
      :width="dialogWidth"
      transition="dialog-transition"
    >
      <v-card
        style="height: 600px; overflow-y: scroll"
        color="primary"
        v-if="urls"
      >
        <v-toolbar color="primary" flat>
          <v-toolbar-title>
            <h3>{{ "Images" }}</h3>
          </v-toolbar-title>
          <v-spacer />

          <v-btn icon @click="closeImage()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <div v-for="url in urls" :key="url">
          <v-divider class="my-2"></v-divider>
            <img 
              style="width: 80%; margin: 0 auto; display: block;"
              :src="url"
            />
        </div>
      </v-card>
    </v-dialog>
    <Create v-model="createView" />

    <v-btn
      fab
      fixed
      bottom
      right
      icon
      color="secondary"
      @click="createView = true"
    >
      <v-icon large>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import Table from "@/components/app/Table";
import Create from "@/components/audits/bol/Create";

import Common from "@/mixins/Common";

export default {
  name: "BOL",

  data() {
    return {
      createView: false,
      imageView: false,
      headers: [
        { text: "Freight Carrier", value: "vendor" },
        { text: "Route", value: "route" },
        { text: "Customer/Vendor", value: "customer" },
        { text: "Sales/Purchase Order #", value: "reference" },
        { text: "Package/Pallet", value: "packageType" },
        { text: "# of Packages/Pallets", value: "packageCount" },
        { text: "Date Received", value: "createDate" },
        { text: "Created By", value: "createdBy.name" },
        { text: "Actions", value: "actions", sortable: false }
      ]
    };
  },

  components: {
    Table,
    Create
  },

  destroyed() {
    this.$store.commit("audits/setAllAudits", []);
    this.$store.commit("audits/setS3URLs", []);
  },

  computed: {
    ...mapGetters({
      allBOLs: "audits/getAllAudits",
      totalItems: "audits/getTotalAudits",
      urls: "audits/getS3URLs"
    }),
    dialogWidth() {
      if (this.$vuetify.breakpoint.xs) {
        return "100%";
      } else if (this.$vuetify.breakpoint.md) {
        return "80%";
      }
      return "70%";
    }
  },

  mixins: [LoginCheck, Common],

  methods: {
    ...mapActions({
      getAudit: "audits/getOne",
      getImages: "audits/getS3Files"
    }),

    async uploadImage(id) {
      await this.getAudit({
        id,
        module: "bol"
      });
      this.createView = true;
    },
    async viewImages(id) {
      await this.getImages({ module: "BOL", id });
      this.imageView = true;
    },
    closeImage() {
      this.imageView = false;
      this.$store.commit("audits/setS3URLs", []);
      this.imageView = false;
    }
  }
};
</script>

<style></style>
